<template>
  <Loader v-if="loading" />
  
  <div class="stato-forniture">
    <div class="header-section">
      <h2 class="page-title">Stato forniture</h2>
      <p class="subtitle">Monitoraggio e gestione delle forniture</p>
    </div>
    
    <div class="content-section">
      <div class="filter-section">
        <div class="date-filter">
          <label class="filter-label">Filtra per Mese:</label>
          <div class="filter-controls">
            <span class="p-input-icon-left calendar-icon-container">
              <i class="pi pi-calendar"></i>
              <Calendar v-model="date" :maxDate="maxDate" :manualInput="false" view="month" dateFormat="mm/yy" @update:modelValue="onChangeDate($event)" class="date-picker"/>
            </span>
          </div>
        </div>
        <Button class="refresh-btn" icon="pi pi-refresh" label="Aggiorna" v-tooltip="`Aggiorna`" @click="mount()"/>
      </div>
      
      <div class="table-container">
        <div class="table-tabs-container">
          <TabView class="forniture-tabs">
            <TabPanel v-for="tab in tabs" :key="tab.title" :header="tab.title">
              <div class="table-controls">
                <div class="filter-buttons-container">
                  <div class="filter-buttons">
                    <Button 
                      v-for="error in filters_error" 
                      :key="error.name" 
                      :class="[`error-filter-btn ${error.severity}`]" 
                      @click="initFilters(error.option)"
                    >
                      {{ error.name }}
                    </Button>
                    <i 
                      v-if="is_filtered" 
                      @click="clearFilter" 
                      class="clear-filter-icon pi pi-times" 
                      v-tooltip="'Rimuovi filtro'"
                    ></i>
                  </div>
                </div>
                
                <div class="search-container">
                  <IconField iconPosition="left" class="search-field">
                    <InputIcon>
                      <i class="pi pi-search" />
                    </InputIcon>
                    <InputText 
                      v-model="filters['global'].value" 
                      placeholder="Ricerca globale..." 
                      @keydown.enter="filterCallback()"
                      class="search-input"
                    />
                    <i 
                      v-if="filters['global'].value" 
                      @click="clearFilter" 
                      class="clear-search-icon pi pi-times" 
                      v-tooltip="'Rimuovi filtro'"
                    ></i>
                  </IconField>
                </div>
              </div>
              
              <DataTable 
                v-model:filters="filters" 
                :globalFilterFields="['matrice_id', 'data_caricamento','code', 'cod_internal_pratica', 'stato', 'cod_stato_caricamento', 'in_ask', 'agente', 'cliente', 'rappresentante', 'precheck', 'caricato']" 
                filterDisplay="row" 
                :value="tab.content" 
                :breakpoint="breakpoint" 
                paginator 
                :rows="20" 
                :rowsPerPageOptions="[20, 50, 100]" 
                sortField="data_caricamento" 
                :sortOrder="-1" 
                :rowClass="rowClass" 
                :responsiveLayout="responsiveLayout"
                class="forniture-table"
              >
                <template #empty>
                  <div class="empty-message">Nessun dato disponibile</div>
                </template>
                
                <Column 
                  v-for="col of columns" 
                  :key="col.field" 
                  :field="col.field" 
                  :header="col.header" 
                  :showFilterMenu="false" 
                  :filterMenuStyle="{ width: '5rem' }"
                >
                  <template #body="{data}">
                    {{data[col.field]}}
                  </template>
                  <template #filter="{ filterModel, filterCallback }">
                    <div v-if="col.field in filters">
                      <Dropdown 
                        v-model="filterModel.value" 
                        @change="filterCallback()" 
                        :options="col.option[tab.title == 'Elettrico' ? 'ee' : 'gas']" 
                        :placeholder="`Filtra`" 
                        class="column-filter" 
                        :showClear="true" 
                        filter 
                        optionLabel="key" 
                        optionValue="key" 
                        @keydown.enter="filterCallback()"
                      />
                    </div>
                  </template>
                </Column>
              </DataTable>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, onMounted, getCurrentInstance, onUpdated, computed } from 'vue';
import Loader from "@/components/Loader.vue"
import Service from '@/services/ask-pratiche/pratiche-wizard'
import moment from 'moment'
import { FilterMatchMode } from 'primevue/api';

   
export default {
  components: {
    Loader,
  },
  
  setup (props, {emit}) { 

    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus

    const loading = ref(false)
    const items_ee = ref([])
    const items_gas = ref([])

    const tabs = ref([]);
    const stati_precheck = ref()
    const stati_contratto = ref()
    const stati_internal_pratica = ref()
    const filters = ref();
    const stati = ref([
      {
        id:1,
        name:'in validazione'
      },
      {
        id:2,
        name:'in precheck'
      },
      {
        id:3,
        name:'ko documenti'
      },
      {
        id:6,
        name:'caricato'
      },
      {
        id:7,
        name:'caricato con ko'
      },
      {
        id:8,
        name:'annullato'
      },
      {
        id:9,
        name:'bloccato'
      },
      {
        id:11,
        name:'standby'
      }
    ]);
    const date = ref(new Date())
    const maxDate = ref(new Date());

    const columns = ref([])
    const service = new Service(self.$eventBus)
    const windowSize = ref(window.innerWidth)
    const breakpoint = ref('800px') 
    const responsiveLayout = ref()
    const filters_error = ref([
      {
        name:'Pronto per lo switch con esito precheck KO',
        option:{
          cod_internal_pratica:'pronto per lo switch',
          precheck:'precheck eseguito, esito KO'
        },
        severity:"warn1"
      },
      {
        name:'Caricato ma non presente su ask',
        option:{
          caricato:'Si',
          in_ask:'No'
        },
        severity:"warn2"
      },
      {
        name:'Pronto per lo switch con precheck da rieseguire',
        option:{
          cod_internal_pratica:'pronto per lo switch',
          precheck:'precheck da rieseguire'
        },
        severity:"warn3"
      },
      {
        name:'Pronto per lo switch con stato contratto OK',
        option:{
          cod_internal_pratica:'pronto per lo switch',
          stato:'OK'
        },
        severity:"warn4"
      },
      {
        name:'Pronto per lo switch con KO documentale',
        option:{
          cod_internal_pratica:'pronto per lo switch',
          cod_stato_caricamento:'ko documenti'
        },
        severity:"warn5"
      },
      {
        name:'Switch in sospeso con esito precheck OK',
        option:{
          cod_internal_pratica:'switch in sospeso',
          precheck:'precheck eseguito, esito OK'
        },
        severity:"warn6"
      }
    ])
    const properties_filter = ref({
      global: FilterMatchMode.CONTAINS,
      matrice_id: FilterMatchMode.CONTAINS,
      code: FilterMatchMode.STARTS_WITH,
      cod_stato_caricamento: FilterMatchMode.EQUALS,
      in_ask: FilterMatchMode.EQUALS,
      caricato: FilterMatchMode.EQUALS,
      stato: FilterMatchMode.EQUALS,
      cod_internal_pratica: FilterMatchMode.EQUALS,
      agente: FilterMatchMode.CONTAINS,
      cliente: FilterMatchMode.CONTAINS,
      rappresentante: FilterMatchMode.CONTAINS,
      precheck: FilterMatchMode.CONTAINS
    })
    const is_filtered = computed(()=>{
      let is_filtered = false
      
      Object.keys(filters.value).forEach(filter=>{
        if (filters.value[filter].value) {
          return is_filtered = true
        }
      })
      return is_filtered
    })



    const ids_ee = ref([]);
    const ids_gas = ref([]);
    const initRef = () => {
      items_ee.value = []
      items_gas.value = []
      tabs.value = []
      stati_precheck.value = []
      stati_contratto.value = []
      stati_internal_pratica.value = []
      filters.value = []
    }

    onMounted(() => { 
      mount()
    })
    onUpdated(() => {
      responsiveLayout.value = windowSize.value > breakpoint.value.replace('px','') ? 'scroll' : 'stack'
      setResponsive()
    })
    const onChangeDate = (evt) => {
      mount()
    }
    const mount = () => {
      responsiveLayout.value = windowSize.value > breakpoint.value.replace('px','') ? 'scroll' : 'stack'
      setResponsive()

      loading.value = true
      initRef()
      const promises_1 = [
        getStatiPrecheck(),
        getStatiInternalPratica(),
        getStatiContratto(),
      ]
      Promise.all(promises_1)

      initColumns()
      initFilters()

      const promises = [
        getData('ee'),
        getData('gas')
      ]


      Promise.all(promises)
      .then(()=>{
        let types = ['ee', 'gas']
        types.forEach(type => {
          setData(type)
        })
      })
      .finally(()=>{
        loading.value = false
      })
    } 

    const setData = (type) => {
      let items = []
      eval(`items_${type}`).value.forEach(row => {
        let item = {}
        Object.keys(row).forEach((prop,i) => {
          item[prop] = setItem(prop,row[prop] ?? '')
        })
        item.severity = setValid(item)
        items.push(item)
        columns.value.forEach((col,index) => {
          columns.value[index].option[type] = populateOption(items, col.field)
        })
      })
      tabs.value.push({
        title: type == 'ee' ? 'Elettrico' : 'Gas',
        content: items
      })
    }

    const setResponsive = () => {
      window.addEventListener('resize', () => {
        windowSize.value = window.innerWidth
        responsiveLayout.value = windowSize.value > breakpoint.value.replace('px','') ? 'scroll' : 'stack'
      })
    }
    const setValid = (data) => {
      let severity = ''
      let array_filtro = []
      filters_error.value.forEach((error,i) => {
        let array_i = []
        Object.keys(error.option).forEach(e=>{
          array_i.push(data[e] == error.option[e])
        })
        array_filtro.push(array_i)
      })        
      for (let id = 0; id < array_filtro.length; id++) {
        if (array_filtro[id][0] && array_filtro[id][1]) {
          severity = filters_error.value[id].severity
          break;
        }
      }
      return severity
    }
    const populateOption = (data, prop) => {
      let list = []
      let item = []
      let fix_option = {
        cod_stato_caricamento: {val:stati.value,property:'name'},
        precheck: {val:stati_precheck.value, property: 'description'},
        in_ask: {val:[{name:'Si'},{name:'No'}],property:'name'},
        stato: {val:stati_contratto.value,property:'name'},
        cod_internal_pratica: {val:stati_internal_pratica.value,property:'description'}
      } 

      if (data.length > 0) {
        if (prop in fix_option) {
          Object.keys(fix_option[prop].val).forEach((i,fix_op) => {
            item.push({key:fix_option[prop].val[i][fix_option[prop].property]})
          })          

        } else {
          data.forEach(el => {
            if (el[prop]) {
              list.push(el[prop])
            }
          });
          list = [...new Set(list)];
  
          list.forEach(prop => {
            item.push({key:prop})
          })          
        }
      }
      return item
    }
    
    const rowClass = (data) => {
      // return data.valid == false ? 'bg-tr-warning' : null ;
      return data.severity != '' ? data.severity : null ;
    };
    const initColumns = () => {
      columns.value = [
        { field: 'matrice_id', header: '#' },
        { field: 'code', header: 'Codice fornitura' },
        { field: 'agente', header: 'Agente' },
        { field: 'cliente', header: 'Cliente' },
        { field: 'rappresentante', header: 'Rappresentante' },
        { field: 'pratica', header: 'Tipo pratica' },
        { field: 'cod_stato_caricamento', header: 'Stato inserimento contratto' },
        { field: 'data_caricamento', header: 'Data inserimento contratto' },
        { field: 'precheck', header: 'Stato Precheck' },
        { field: 'dettaglio_esito_precheck', header: 'Dettaglio esito precheck' },
        { field: 'caricato', header: 'Caricato' },
        { field: 'in_ask', header: 'Presente su Ask' },
        { field: 'stato', header: 'Stato Contratto' },
        { field: 'data_inizio', header: 'Data inizio fornitura'},
        { field: 'data_fine', header: 'Data fine fornitura'},
        { field: 'cod_internal_pratica', header: 'Codice interno'},
      ]

      columns.value.forEach((col,index) => {
        columns.value[index]['option'] = []
      })
    }
    const initFilters = (option = []) => {
      filters.value = {}

      Object.keys(properties_filter.value).forEach(prop=>{
        filters.value[prop] = {
          value: prop in option ? option[prop] : null,
          matchMode: properties_filter.value[prop]
        }
      })
    };

    const setItem = (field, data) => {
      switch (field) {
        case 'cod_stato_caricamento':
          data = data ? stati.value.find(stato => stato.id == data).name : ''
          break;
        case 'precheck':
          data = data ? stati_precheck.value.find(stato => stato.code == data).description : ''
          break;
        case 'stato':
          data = data ? stati_contratto.value.find(stato => stato.value == data).name : ''
          break;
        case 'cod_internal_pratica':
          data = data ? stati_internal_pratica.value.find(stato => stato.code == data).description : ''
          break;

        case 'data_caricamento':
        case 'data_firma':
        case 'data_inizio':
        case 'data_fine':
          data = data ? moment(data).format('DD-MM-YYYY') : '--'
          break;

        case 'in_ask':
        case 'caricato':
          data = data ? 'Si' : 'No'
          break;

        default:
          break;
      }
      return data
    }
    const getData = async (type) => {
      let fd = new FormData();
      
      let mese = date.value.getMonth()+1
      mese = mese.toString().padStart(2,'0')
      let anno = date.value.getFullYear() 
      let filtro = `${anno}-${mese}`
      fd.append('filtro', filtro);

      await service.getDetailsSupplies(type, fd)
      .then((res)=>{
        eval(`items_${type}`).value = res.items
      })
    }

    const getStatiPrecheck = async () => {
      await service.getStatiPrecheck()
      .then((res) => {
        stati_precheck.value = res.items
      })
    }
    const getStatiContratto = async () => {
      await service.getStatiContratto()
      .then((res) => {
        stati_contratto.value = res.items
      })
    }
    const getStatiInternalPratica = async () => {
      await service.getStatiInternalPratica()
      .then((res) => {
        stati_internal_pratica.value = res.items
      })
    }

    const clearFilter = () => {
      initFilters();
    };


    return {
      loading,
      items_ee,
      items_gas,
      tabs,
      columns,
      stati,
      setItem,
      moment,
      filters,
      initFilters,
      clearFilter,
      rowClass,
      responsiveLayout,
      breakpoint,
      windowSize,
      date,
      maxDate,
      onChangeDate,
      filters_error,
      is_filtered,
      mount,
    }
  },
}
</script>

<style>
.warn1 {
  background-color: rgba(255, 0, 0, 0.9) !important;
  color: white !important;
}
.warn2 {
  background-color: rgba(255, 66, 66, 0.9) !important;
  color: white !important;
}
.warn3 {
  background-color: rgba(255, 106, 0, 0.9) !important;
  color: white !important;
}
.warn4 {
  background-color: rgba(255, 120, 52, 0.9) !important;
  color: white !important;
}
.warn5 {
  background-color: rgba(255, 217, 0, 0.9) !important;
  color: #212529 !important;
}
.warn6 {
  background-color: rgba(250, 222, 66, 0.9) !important;
  color: #212529 !important;
}
</style>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

.stato-forniture {
  font-family: 'Montserrat', sans-serif;
  padding: 1.5rem;
  max-width: 100%;
}

/* Header Section */
.header-section {
  margin-bottom: 1.5rem;
}

.page-title {
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.subtitle {
  color: #666;
  font-size: 1rem;
}

/* Content Section */
.content-section {
  margin-bottom: 1.5rem;
}

/* Filter Section */
.filter-section {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 1.2rem 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.date-filter {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.filter-label {
  color: #555;
  font-weight: 500;
  font-size: 1rem;
}

.filter-controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.calendar-icon-container {
  position: relative;
}

:deep(.date-picker) {
  min-width: 180px;
}

:deep(.date-picker .p-inputtext) {
  padding-left: 2.5rem;
  border-radius: 4px;
  transition: all 0.2s;
}

:deep(.date-picker .p-inputtext:hover) {
  border-color: #3498db;
}

:deep(.date-picker .p-inputtext:focus) {
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.15);
}

:deep(.refresh-btn) {
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 0.6rem 1rem;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

:deep(.refresh-btn:hover) {
  background-color: #2980b9;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

:deep(.refresh-btn:active) {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Table Container */
.table-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.table-tabs-container {
  padding: 0;
}

/* TabView */
:deep(.forniture-tabs) {
  padding: 0;
}

:deep(.forniture-tabs .p-tabview-nav) {
  background-color: #f8f9fa;
  padding: 0 1.5rem;
  border-bottom: 1px solid #eee;
}

:deep(.forniture-tabs .p-tabview-nav li .p-tabview-nav-link) {
  background-color: transparent;
  color: #666;
  padding: 1rem 1.5rem;
  font-weight: 500;
  border: none;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}

:deep(.forniture-tabs .p-tabview-nav li .p-tabview-nav-link:hover) {
  background-color: rgba(52, 152, 219, 0.05);
  border-color: rgba(52, 152, 219, 0.2);
  color: #3498db;
}

:deep(.forniture-tabs .p-tabview-nav li.p-highlight .p-tabview-nav-link) {
  background-color: transparent;
  color: #3498db;
  border-bottom: 2px solid #3498db;
}

:deep(.forniture-tabs .p-tabview-panels) {
  padding: 0;
}

/* Table Controls */
.table-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 1rem 1.5rem;
  background-color: white;
  border-bottom: 1px solid #eee;
}

.filter-buttons-container {
  overflow-x: auto;
  max-width: 70%;
}

.filter-buttons {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem;
  align-items: center;
  min-width: max-content;
}

.error-filter-btn {
  font-size: 0.8rem;
  padding: 0.5rem 0.8rem;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
  border: none;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.error-filter-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}

.clear-filter-icon {
  color: #e74c3c;
  cursor: pointer;
  font-size: 1.2rem;
  margin-left: 0.5rem;
  transition: all 0.2s;
  background-color: rgba(231, 76, 60, 0.1);
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.clear-filter-icon:hover {
  color: #c0392b;
  background-color: rgba(231, 76, 60, 0.2);
}

/* Search Container */
.search-container {
  display: flex;
  align-items: center;
}

.search-field {
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  border: 1px solid #eee;
  border-radius: 20px;
  padding: 0 0.8rem;
  transition: all 0.2s;
}

.search-field:focus-within {
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.15);
}

:deep(.search-input) {
  background-color: transparent;
  border: none;
  padding: 0.6rem;
  width: 250px;
}

:deep(.search-input:focus) {
  box-shadow: none;
}

.clear-search-icon {
  color: #e74c3c;
  cursor: pointer;
  font-size: 1rem;
  margin-left: 0.5rem;
  transition: all 0.2s;
}

.clear-search-icon:hover {
  color: #c0392b;
}

/* DataTable */
:deep(.forniture-table) {
  border-radius: 0;
  overflow: hidden;
}

:deep(.forniture-table .p-datatable-wrapper) {
  border-radius: 0;
  overflow: auto;
}

:deep(.forniture-table .p-datatable-thead > tr > th) {
  background-color: #f8f9fa;
  padding: 0.9rem 1rem;
  font-weight: 500;
  color: #444;
  border-color: #eee;
  position: sticky;
  top: 0;
  z-index: 1;
}

:deep(.forniture-table .p-datatable-tbody > tr > td) {
  padding: 0.8rem 1rem;
  border-color: #f0f0f0;
  font-size: 0.95rem;
}

:deep(.forniture-table .p-datatable-tbody > tr:nth-child(even)) {
  background-color: #fafafa;
}

:deep(.forniture-table .p-datatable-tbody > tr:hover) {
  background-color: rgba(52, 152, 219, 0.05);
}

:deep(.forniture-table .p-paginator) {
  background-color: #f8f9fa;
  border-top: 1px solid #eee;
  padding: 0.7rem;
}

:deep(.forniture-table .p-paginator .p-paginator-pages .p-paginator-page) {
  border-radius: 50%;
  width: 2.2rem;
  height: 2.2rem;
  margin: 0 0.2rem;
}

:deep(.forniture-table .p-paginator .p-paginator-pages .p-paginator-page.p-highlight) {
  background-color: #3498db;
  color: white;
}

/* Column Filters */
:deep(.column-filter) {
  width: 100%;
  font-size: 0.85rem;
}

:deep(.column-filter .p-dropdown-label) {
  padding: 0.4rem 0.6rem;
}

:deep(.p-column-filter-row .p-column-filter-menu-button) {
  width: 2rem;
  height: 2rem;
}

:deep(.p-column-filter-row .p-column-filter-menu-button:hover) {
  background-color: rgba(52, 152, 219, 0.1);
  color: #3498db;
}

/* Empty Message */
.empty-message {
  text-align: center;
  color: #777;
  padding: 3rem;
  font-style: italic;
  background-color: #f9f9f9;
  border-radius: 6px;
  margin: 1.5rem;
}

/* Responsive */
@media (max-width: 768px) {
  .filter-section {
    flex-direction: column;
    gap: 1rem;
  }
  
  .date-filter {
    width: 100%;
  }
  
  .filter-controls {
    width: 100%;
  }
  
  :deep(.date-picker) {
    width: 100%;
  }
  
  .table-controls {
    flex-direction: column;
    gap: 1rem;
  }
  
  .filter-buttons-container {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    margin-bottom: 0.5rem;
  }
  
  .search-container {
    width: 100%;
  }
  
  .search-field {
    width: 100%;
  }
  
  :deep(.search-input) {
    width: 100%;
  }
}
</style>